// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3Ak90","content":"RecentSearches_content__3zwFn"};